"use client";
import { useEffect } from "react";
import useSWR from "swr";
import { fetcherAlegriia } from "@utils/requests";
import { useShallow } from "zustand/react/shallow";
import { useStore } from "../../core";
import { IUser } from "../../core/types";
import { AxiosError } from "axios";
import { ErrorAlert } from "@components/CustomAlert";

export function ValidateToken() {
  const { token, cleanToken } = useStore(
    useShallow((state) => ({
      token: state.token,
      cleanToken: state.cleanToken,
    }))
  );

  const { error } = useSWR<IUser>(
    token && { url: "/welcome", auth: token },
    fetcherAlegriia
  );

  useEffect(() => {
    if (!error) return;
    else if (!!token && (error as AxiosError)?.code === "400")
      ErrorAlert(error?.response?.data?.error);
    else if (!!token && error?.response?.data?.error === "Invalid Token")
      cleanToken?.();
  }, [cleanToken, error, token]);
  return null;
}
